<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">护理项目编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="addForm" :rules="rules" ref="addForm" >
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="名称" prop="name">
                                    <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="护理类型" prop="nursingTypeCode">

                                    <el-select v-model="addForm.nursingTypeCode" placeholder="选择护理类型" clearable filterable @change="changeNursingTypeCode" style="width:100%">
                                        <el-option
                                                v-for="item in nursingTypeList"
                                                :key="item.nursingTypeCode"
                                                :label="item.name"
                                                :value="item.nursingTypeCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="排序" prop="sort">
                                    <el-input v-model.number="addForm.sort" placeholder="请输入排序"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="护理项目状态" required prop="status">
                                    <el-select v-model="addForm.status" placeholder="请选择状态" @change="changeStatus" style="width:100%">
                                        <el-option
                                                v-for="item in status2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        data() {
            return {
                loading: false,
                nursingLevelList: null,
                nursingTypeList: null,

                listMenuDTO:[],
                defaultProps: {
                    children: 'listMenuDTO',
                    label: 'name'
                },
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    nursingItemCode:'',
                    name:'',
                    sort:'',
                    nursingLevelCode:'',
                    nursingTypeCode:'',
                    status:''

                },
                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],
                rules:{
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                    ],
                    sort: [
                        {required: true, message: '请输入排序', trigger: 'blur'},
                        {type: 'number', message: '排序必须为数字值', trigger: 'blur'}
                    ],
                    nursingTypeCode: [
                        {required: true, message: '请选择护理类型', trigger: 'blur'},
                    ],

                }

            }
        },

        methods: {

            init(row){
                this.addForm.name = row.name;
                this.addForm.sort = row.sort;
                this.addForm.nursingTypeCode=row.nursingTypeCode;
                this.addForm.nursingItemCode=row.nursingItemCode;
                this.addForm.status=row.status
                this.getNursingTypeList();
            },

            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(addForm) {
                this.$refs[addForm].validate((valid) => {
                    if (valid) {
                        this.addSubmit();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            changeNursingTypeCode(selVal) {
                this.nursingTypeCode = selVal;
            },

            changeNursingLevelCode(Val) {
                this.nursingLevelCode = Val;
            },
            changeStatus:function (selVal) {
                this.addForm.status = selVal;
            },

            getNursingTypeList() {
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + 'NursingType/List',
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response) => {
                    console.log(response.data);
                    if (response.data.error == 0) {
                        this.nursingTypeList = response.data.data;
                        this.nursingTypeCode = this.nursingTypeList[0].nursingTypeCode;
                    } else if (response.data.error == 1) {
                        this.$message(response.data.message);
                    } else {
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"NursingItem/Edit",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else {
                            this.$message({type: 'info', message: '编辑失败'});
                        }
                    }
                )
            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }



</style>
